/**
 * Small DOM overlay in the top-left of the game stage showing the live
 * `Character.discoveries` count (ADR-0012 §7). Sits below the existing
 * "Playing as …" HUD line. Updates via `setCount` — `App.ts` calls it
 * after every cross.
 *
 * `discoveries` are first-cross-globally events: the count rises only when
 * this character is the first traveller ever to step onto a tile. It is
 * distinct from a per-character "tiles walked" total (which is the size of
 * `Character.explored`). The hover title makes that distinction visible.
 */

export const DISCOVERY_HUD_TITLE =
  'Tiles you were first to cross (global). Different from tiles walked.';

export class DiscoveryHud {
  private root: HTMLDivElement | null = null;
  private valueEl: HTMLSpanElement | null = null;
  private count = 0;

  constructor(private readonly container: HTMLElement) {}

  mount(initial: number): void {
    if (this.root) return;
    this.count = initial;
    const root = document.createElement('div');
    root.className = 'hex6-discovery-hud';
    root.title = DISCOVERY_HUD_TITLE;

    const label = document.createElement('span');
    label.className = 'hex6-discovery-hud__label';
    label.textContent = 'Discovered';

    const value = document.createElement('span');
    value.className = 'hex6-discovery-hud__value';
    value.textContent = String(initial);

    root.append(label, value);
    this.container.appendChild(root);
    this.root = root;
    this.valueEl = value;
  }

  setCount(next: number): void {
    if (next === this.count) return;
    this.count = next;
    if (this.valueEl) this.valueEl.textContent = String(next);
  }

  getCount(): number {
    return this.count;
  }

  destroy(): void {
    this.root?.remove();
    this.root = null;
    this.valueEl = null;
  }
}
